import React, { forwardRef, useState, useEffect } from 'react';
import { CnCodeDiffEditorCore } from '../cn-code-diff-editor-core';
const CnCodeDiffEditor = forwardRef((props) => {
    const { className, style, language, onCreated, sqlOptions, supportLanguages, editorOptions, original, modified, } = props;
    const [proxyOriginal, setProxyOriginal] = useState('');
    const [proxyModified, setProxyModified] = useState('');
    const [isEditorInit, setIsEditorInit] = useState(false);
    const handleCreated = (editor) => {
        setIsEditorInit(true);
        onCreated && onCreated(editor);
    };
    useEffect(() => {
        if (isEditorInit) {
            setProxyOriginal(original);
            setProxyModified(modified);
        }
    }, [isEditorInit, original, modified]);
    return (<CnCodeDiffEditorCore className={className} style={style} language={language} onCreated={handleCreated} sqlOptions={sqlOptions} supportLanguages={supportLanguages} editorOptions={editorOptions} modified={proxyModified} original={proxyOriginal}/>);
});
CnCodeDiffEditor.displayName = 'CnCodeDiffEditor';
export { CnCodeDiffEditor };
